import axios from "axios"
import { baseURL } from "../config/api";

export const getFaqs = (tenantId: string) => {
    return getFetch("faq", tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}